import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiService} from '../../../services/api.service';
import {ErrorService} from '../../../shared/error-page/service/error-service';

import {Constants} from '../../../constants/ebtq-constants';
import {UserDetailsModel} from '../../../constants/userModel';
import { UtilityService } from '../../../services/utility-service';
import {SeasonedLoanFeesWrapper} from '../../../model/seasonedLoanFeesWrapper';

@Component({
  standalone: false,
  selector: 'app-update-season-loan-fee',
  templateUrl: './update-season-loan-fee.component.html',
  styleUrls: ['./update-season-loan-fee.component.scss']
})
export class UpdateSeasonLoanFeeComponent implements OnInit {

  selNumber!: string;
  contractNumber!: string;
  showErrorDiv = false;
  errHeading!: string;
  selNumErrMessage!: string;
  conNumErrMessage!: string;
  selNumErrBoo = false;
  conNumErrBoo = false;
  containsError = false;
  errorMsg!: string;
  loanFee!: string;
  isSearch = true;
  isUpdate = false;
  isAdd = false;
  isDelete = false;
  isLoanFeeAvail = false;
  isCanMain = true;
  isCanLoc = false;
  isSave = false;
  editModeSel = true;
  editModeConNum = true;
  isConfirmDel = false;
  editLoanFee = true;
  displayMess = false;
  rssSuccMess = '';
  userDetails!: UserDetailsModel;

  constructor(private utilityService: UtilityService, private httpService: HttpClient, private apiService: ApiService, private errorService: ErrorService, private cdr: ChangeDetectorRef) {
    this.reset();
  }

  ngOnInit(): void {
    this.errHeading = Constants.ERR_HEADER;
    this.conNumErrMessage = Constants.CON_NUM_ERR;
    this.selNumErrMessage = Constants.SEL_NUM_ERR;
    this.userDetails = Constants.USER_DETAILS;
  }

  getSeasonedLoanFeesWrapperObj() {
    const request = new SeasonedLoanFeesWrapper();
    if (this.selNumber === undefined || this.selNumber.trim() === '') {
      request.sellerNumber = undefined;
    } else {
      request.sellerNumber = this.selNumber;
    }
    if (this.contractNumber === undefined || this.contractNumber.trim() === '') {
      request.contractNumber = undefined;
    } else {
      request.contractNumber = this.contractNumber;
    }
    if (this.loanFee === undefined || this.loanFee === '') {
      request.seasonedLoanFeeAmount = undefined;
    } else if (this.loanFee !== undefined) {
      request.seasonedLoanFeeAmount = '' + this.loanFee;
    }
    request.username = sessionStorage.getItem('userID') ?? '';
    return request;
  }

  saveLoanFee() {
    if (this.validateInput()) {
      this.showErrorDiv = false;
      const request = this.getSeasonedLoanFeesWrapperObj();
      if (this.loanFee === undefined || this.loanFee === '' || this.loanFee.trim() === '') {
        request.seasonedLoanFeeAmount = '0';
      } else {
        request.seasonedLoanFeeAmount = this.loanFee;
      }
      this.apiService.addSeasonLoanData(request).subscribe(
        () => {
          this.displayMess = true;
          this.rssSuccMess = Constants.ADD_SEASON_LOAN_MESS;
          this.cdr.detectChanges();
        },
        error => {
          this.errorService.announceError(error);
        });
      this.errorAnnouncement();
    }
  }

  addLoanFee() {
    this.selNumber = '';
    this.contractNumber = '';
    this.loanFee = '';
    this.isSearch = false;
    this.isDelete = false;
    this.isAdd = false;
    this.isSave = true;
    this.isCanMain = false;
    this.isCanLoc = true;
    this.isLoanFeeAvail = true;

  }

  ConfirmDelete() {
    const request = new SeasonedLoanFeesWrapper();
    request.sellerNumber = this.selNumber;
    request.contractNumber = this.contractNumber;
    this.apiService.deleteSeasonLoanData(request).subscribe(
      () => {
        this.reset();
        this.displayMess = true;
        this.rssSuccMess = this.utilityService.stringReplace(Constants.DEL_SEASON_LOAN, this.selNumber, this.contractNumber);
        this.selNumber = '';
        this.contractNumber = '';
        this.cdr.detectChanges();
      },
      error => {
        this.errorService.announceError(error);
      });
    this.errorAnnouncement();
  }

  deleteLoanFee() {
    this.isConfirmDel = true;
    this.isUpdate = false;
    this.editLoanFee = false;
    this.search();

  }

  updateLoanFee() {
    const request = new SeasonedLoanFeesWrapper();
    if (this.selNumber === 'Default Seller Number' && this.contractNumber === 'Default Contract  Number') {
      request.sellerNumber = undefined;
      request.contractNumber = undefined;
    } else {
      request.sellerNumber = this.selNumber;
      request.contractNumber = this.contractNumber;
    }
    if (this.loanFee === undefined || this.loanFee === '' || this.loanFee.trim() === '') {
      request.seasonedLoanFeeAmount = '0';
    } else {
      request.seasonedLoanFeeAmount = this.loanFee;
    }
    request.username = sessionStorage.getItem('userID') ?? '';

    this.apiService.updateSeasonLoanFees(request).subscribe(
      () => {
        this.displayMess = true;
        this.rssSuccMess = Constants.UPDT_SEASON_LOAN_MESS;
        if (this.loanFee === undefined || this.loanFee.trim() === '') {
          this.loanFee = '0';
        }
        this.cdr.detectChanges();
      },
      error => {
        this.errorService.announceError(error);
      });
    this.errorAnnouncement();
  }

  cancelLocal() {
    if (this.selNumber === 'Default Seller Number' && this.contractNumber === 'Default Contract  Number') {
      this.selNumber = '';
      this.contractNumber = '';
    }
    this.reset();
  }

  reset() {
    this.isSearch = true;
    this.isAdd = true;
    this.isDelete = true;
    this.isUpdate = false;
    this.isLoanFeeAvail = false;
    this.isCanMain = true;
    this.isCanLoc = false;
    this.isSave = false;
    this.editModeSel = true;
    this.editModeConNum = true;
    this.isConfirmDel = false;
    this.editLoanFee = true;
    this.showErrorDiv = false;
    this.displayMess = false;
  }

  validateInput() {
    let isValidate = true;
    this.selNumErrBoo = false;
    this.conNumErrBoo = false;
    if (!this.isSave && (this.selNumber === undefined || this.selNumber === '') && (this.contractNumber === undefined || this.contractNumber === '')) {
      return isValidate;
    }
    if (this.selNumber.length !== 9) {
      isValidate = false;
      this.selNumErrBoo = true;
    }
    if (this.contractNumber.length !== 6) {
      isValidate = false;
      this.conNumErrBoo = true;
    }
    if (!isValidate) {
      this.showErrorDiv = true;
      this.displayMess = false;
    }
    return isValidate;
  }

  search() {
    if (this.validateInput()) {
      const request = this.getSeasonedLoanFeesWrapperObj();
      this.apiService.getSeasonedLoanFees(request)
        .subscribe(
          (data: any) => {
            this.showErrorDiv = false;
            this.displayMess = false;
            if (data == null) {
              this.displayMess = true;
              this.rssSuccMess = this.utilityService.stringReplace(Constants.SEARCH_DATA_NOT_FOUND, this.selNumber, this.contractNumber);
            } else {
              this.loanFee = data;
              this.isSearch = false;
              this.isAdd = false;
              this.isDelete = false;
              this.isLoanFeeAvail = true;
              this.isCanLoc = true;
              this.isCanMain = false;
              this.editModeSel = false;
              this.editModeConNum = false;
              if (!this.isConfirmDel) {
                this.isUpdate = true;
              }
              if ((this.selNumber === undefined || this.selNumber.trim() === '') && (this.contractNumber === undefined || this.contractNumber.trim() === '')) {
                this.selNumber = 'Default Seller Number';
                this.contractNumber = 'Default Contract  Number';
                this.isUpdate = true;
                this.isConfirmDel = false;
                this.editLoanFee = true;
              }
            }
            this.cdr.detectChanges();
          },
          error => {
            this.errorService.announceError(error);
          });
      this.errorAnnouncement();
    }
  }

  errorAnnouncement() {
    // error announcement
    this.errorService.errorAnnouncedSource$.subscribe(
      message => {
        if (message.includes('violated while insert addSeasonedLoan')) {
          this.displayMess = true;
          this.rssSuccMess = Constants.ADD_SEASON_LOAN_EXCP_MESS;
        } else {
          this.errorMsg = message;
          this.containsError = true;
        }
        this.cdr.detectChanges();
      });
  }
}
